import { ColDef } from "@ag-grid-community/core";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";

import CHECKBOX_COLUMN_DEF from "@app/util/fieldModel/checkBoxColumnDef";

const GROUP_COLUMN_DEF: ColDef = {
  ...CHECKBOX_COLUMN_DEF,
  cellRenderer: "agGroupCellRenderer",
  cellRendererParams: {
    checkbox: true,
    // do not render any values in this cell (except for the checkbox and arrow)
    innerRenderer: () => null,
    suppressCount: true,
    suppressPadding: true,
  },
  headerComponent: "checkboxSelectionHeader",
  showRowGroup: true,
  type: [FieldFeature.ALWAYS_VISIBLE],
  width: 80,
};

export default GROUP_COLUMN_DEF;
